import { useState, useRef, useEffect, useContext } from 'react';
import { programmeContext, pageContext, pagesContext } from '../../contexts';
import Annotation from '../../components/annotation/annotation';

function Slider() {
  // États et refs
  const [isResizing, setIsResizing] = useState(false);
  const [position, setPosition] = useState(50);
  const [annotation, setAnnotation] = useState(null);
  const containerRef = useRef(null);
  const { setCurrent, setHeaderLevel } = useContext(pageContext);
  const pageDatas = useContext(pagesContext);
  const programmeDatas = useContext(programmeContext);

  useEffect(() => {
    if (pageDatas.slider) {
      setHeaderLevel(1);
      setCurrent("slider");
      setTimeout(() => {
        setCurrent("slider");
      }, (200));
      setAnnotation(pageDatas.slider.annotationText);
    }
  }, [pageDatas]);

  // Chemins des images
  const avantSrc = `/public/programmes/${programmeDatas.name}/slider/${pageDatas.slider.image_avant}`;
  const apresSrc = `/public/programmes/${programmeDatas.name}/slider/${pageDatas.slider.image_apres}`;

  // Gestion du slider
  const handleMove = (event) => {
    if (!isResizing || !containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = 'touches' in event
      ? event.touches[0].clientX - rect.left
      : event.clientX - rect.left;

    const newPosition = Math.min(Math.max((x / rect.width) * 100, 0), 100);
    setPosition(newPosition);
  };

  const handleMouseDown = () => setIsResizing(true);
  const handleMouseUp = () => setIsResizing(false);

  const handleClick = (event) => {
    event.preventDefault();

    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const newPosition = Math.min(Math.max((x / rect.width) * 100, 0), 100);

    setPosition(newPosition);
    setIsResizing(true);
  };

  // Gestion des événements
  useEffect(() => {
    if (isResizing) {
      window.addEventListener('mousemove', handleMove);
      window.addEventListener('touchmove', handleMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchend', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchend', handleMouseUp);
    };
  }, [isResizing]);

  return (
    <div id="slider" className="container-slider">
      <div ref={containerRef} className="image-comparison" onMouseDown={handleClick}>
        <img src={apresSrc} alt="Après" className="image-slider" />

        <div
          className="image-before-container"
          style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
        >
          <img src={avantSrc} alt="Avant" className="image-slider" />
        </div>

        <div
          className={`slider ${isResizing ? "draggable" : ""}`}
          style={{ left: `${position}%` }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          <div className="slider-svg">
            <svg viewBox="0 0 237 237" xmlns="http://www.w3.org/2000/svg">
              <path d="M77.659,178.73l-60.374,-60.374l60.374,-60.375l-0,120.749Z" fill="white" />
              <path d="M159.901,58.908l59.448,59.448l-59.448,59.448l0,-118.896Z" fill="white" />
              <path d="M117.817,17.823l100.532,100.533l-100.532,100.532l-100.532,-100.532l100.532,-100.533Z" fill="transparent" stroke='transparent' stroke-width="0px" />
            </svg>
          </div>
        </div>
      </div>

      {annotation && <Annotation text={annotation} leftoffset={50} top={true} />}
    </div >
  );
}

export default Slider;